// eslint-disable-next-line no-restricted-imports
import {
  MutationInput_OperationController_UpdateById_Input_ExecutionMethod,
  UpdateOperationDto_Input,
} from 'api/generated/graphql';
import { CreateAndUpdateOperationParams } from 'api/types/params';
import { formatToISODate, formatToISODateTime } from 'helpers';

export const parseUpdateOperationParams = (
  params: CreateAndUpdateOperationParams
): Omit<UpdateOperationDto_Input, 'versionNumber'> => ({
  orderId: params.orderId,
  number: params.number,
  executedAt: formatToISODateTime(params.executedAt),
  executionPlaceDirectoryRecordId: params.executionPlaceDirectoryRecordId,
  executionMethod:
    MutationInput_OperationController_UpdateById_Input_ExecutionMethod[
      params.executionMethod
    ],
  isSpecializedTrade: params.isSpecializedTrade,
  traderId: params.traderId,
  counterpartyName: params.counterpartyName || null,
  quantity: params.quantity,
  netUnitPrice: params.netUnitPrice,
  unitPrice: params.unitPrice || null,
  accruedCouponIncome: params.accruedCouponIncome || null,
  volume: params.volume,
  settlementDate: formatToISODate(params.settlementDate),
  exchangeRate: params.exchangeRate || null,
  confirmationFileIds: params.confirmationFileIds,
  additionalNotes: params.additionalNotes,
});
